import { twMerge } from 'tailwind-merge';

import { BankRound } from '@/shared/assets';
import { Typography } from '@/shared/ui';

interface ItemProps {
  item: { id: string; label: string };
  isSelected?: boolean;
  onClick: (item: { id: string; label: string }) => void;
}

export const SelectItem = ({ item, isSelected, onClick }: ItemProps) => {
  return (
    <div
      className="grid cursor-pointer grid-cols-[56px_1fr_max-content] items-center py-2"
      onClick={() => {
        onClick(item);
      }}
      role="button"
    >
      <BankRound className="h-[34px] w-[34px]" />

      <Typography variant="16-r">{item.label}</Typography>

      <div
        className={twMerge(
          'flex h-[20px] w-[20px] flex-1 items-center justify-center rounded-full border-2 border-base-100',
          isSelected && 'border-brand-500',
        )}
      >
        <div
          className={twMerge(
            'hidden',
            isSelected &&
              'flex h-[10px] !w-[10px] max-w-[10px] flex-1 rounded-full bg-brand-500',
          )}
        ></div>
      </div>
    </div>
  );
};
